import { client } from './api-client';

export const mggFetchConfiguration = () => client.get(`mgg/configuration`);
